import { defineMessages } from 'react-intl-next';

export default defineMessages({
    manageHc: {
        defaultMessage: 'View all help centers',
        description: 'Message for navigating to hc-management screen in the multi hc dropdown',
        id: 'multi-hc-dropdown.manage-hc',
    },
    createHc: {
        defaultMessage: 'Create help center',
        description: 'Message for create help center button in the multi hc dropdown',
        id: 'multi-hc-dropdown.create-hc',
    },
});
